import React from 'react'; // Import React library
import ReactDOM from 'react-dom/client'; // Import ReactDOM for rendering components to the DOM

// import 'react-toastify/dist/ReactToastify.css'; // Import CSS for React-Toastify notifications
import App from './App'; // Import the main App component

import { AuthProvider } from './components/AuthContext'; // Import AuthProvider for managing authentication context

// Create a root reference using ReactDOM's new createRoot API
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the app within React.StrictMode for highlighting potential problems
root.render(
  <React.StrictMode>
    <AuthProvider> {/* Wrap the App component with AuthProvider to provide authentication context to the entire app */}
      <App /> {/* Main application component */}
    </AuthProvider>
  </React.StrictMode>
);
